import {computed, createApp, ref} from "vue";
import SpecialWishModal from "../../components/SpecialWishModal.vue";
import i18n from "@/plugins/i18n";
import {isTablet} from "@/plugins/Helpers";
import {Loader} from '@webstacz/shop-components';
import axios from '@/plugins/axios';

const el = document.createElement('div');
document.body.appendChild(el);
createApp(SpecialWishModal)
    .use(i18n)
    .mount(el);

document.addEventListener('DOMContentLoaded', () => {
    for (const button of document.querySelectorAll('.open-product-special-wish-modal')) {
        const texts = JSON.parse(button.getAttribute('data-texts'));
        const config = JSON.parse(button.getAttribute('data-config'));
        const loaderEl = document.createElement('div');
        document.body.append(loaderEl);

        const app = createApp({
            components: { Loader },
            template: `
                <div :class="{'is-responsive': isResponsive}">
                    <Loader :visible="loader"/>
                </div>
            `,
            setup() {
                const loader = ref(false);
                const isResponsive = computed(() => isTablet());
                return { loader, isResponsive };
            },
        });
        app.use(i18n);
        const vm = app.mount(loaderEl);

        button.addEventListener('click', (e) => {
            e.preventDefault();

            window.openSpecialWishModal(
                { texts, allowAttachments: true },
                async (form) => {
                    try {
                        vm.loader = true;
                        axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrfToken;

                        const { data } = await axios.post(config.url, {
                            email: form.email,
                            phone: form.phone,
                            message: form.message,
                            confirmation: form.confirmation,
                            url: config.current_url,
                            meta_data: {
                                product_id: config.product_id,
                                product_type: config.product_type,
                            },
                            recaptcha_score: form.recaptchaScore,
                            ...(form.files?.length && {
                                files: form.files.map(({filename, content_type, src}) => ({filename, content_type, src})),
                            }),
                        });

                        pushDataLayersEvent(config, form.email);

                        return data.successUrl ?? '';
                    } finally {
                        vm.loader = false;
                    }
                },
            );
        });
    }
});

const pushDataLayersEvent = (config, email) => {
    document.dispatchEvent(new CustomEvent('productSpecialWishModalSentEvent', {
        detail: {
            product_id: config.product_id,
            product_type: config.product_type,
            product_price: config.product_price,
            configuration_id: config.configuration_id,
            email,
        },
    }));
};
